export default {
  getTransactionModuleTask: (state) => state.transactionModuleTask,
};
